import {
  BaseQueryApi,
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
  fetchBaseQuery,
} from '@reduxjs/toolkit/query/react';
import { Mutex } from 'async-mutex';
import { TokenType, getTokenDetails, storeToken } from '~/redux/utils';

const mutex = new Mutex();

const authBaseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_AUTH_SVC_ENDPOINT,
});

const generateToken = async (api: BaseQueryApi, extraOptions: object) => {
  const { refresh_token } = getTokenDetails();

  if (refresh_token) {
    return await authBaseQuery(
      {
        url: '/token',
        method: 'POST',
        body: {
          client_id: process.env.REACT_APP_CLIENT_ID,
          client_secret: process.env.REACT_APP_CLIENT_SECRET,
          grant_type: 'refresh_token',
          refresh_token,
        },
      },
      api,
      extraOptions,
    );
  }
};

const generateBaseToken = async (api: BaseQueryApi, extraOptions: object) => {
  return await authBaseQuery(
    {
      url: '/token',
      method: 'POST',
      body: {
        client_id: process.env.REACT_APP_CLIENT_ID,
        client_secret: process.env.REACT_APP_CLIENT_SECRET,
        grant_type: 'client_credentials',
      },
    },
    api,
    extraOptions,
  );
};

const fetchWithReauth = (baseQuery: any) => {
  const baseQueryWithReauth: BaseQueryFn<
    string | FetchArgs,
    unknown,
    FetchBaseQueryError
  > = async (args, api, extraOptions) => {
    await mutex.waitForUnlock();
    let result = await baseQuery(args, api, extraOptions);

    const statusError =
      result.error?.status === 403 ||
      result.error?.status === 401 ||
      result.error?.originalStatus === 403 ||
      result.error?.originalStatus === 401;

    if (result.error && statusError) {
      if (!mutex.isLocked()) {
        const release = await mutex.acquire();

        try {
          const refreshResult = (await generateToken(api, extraOptions)) as {
            data: TokenType;
          };
          storeToken(refreshResult);
        } catch {
          const refreshResult = (await generateBaseToken(
            api,
            extraOptions,
          )) as {
            data: TokenType;
          };
          storeToken(refreshResult);
        } finally {
          release();
        }
      } else {
        await mutex.waitForUnlock();
      }

      result = await baseQuery(args, api, extraOptions);
    }

    return result;
  };
  return baseQueryWithReauth;
};
export default fetchWithReauth;
